import React, { useContext, useState, useCallback, useEffect } from 'react'
import { store } from '../../../context/StateProvider'
import CommonService from '../../../services/api/common.service'
import { debounce } from 'lodash'
import AsyncSelect from 'react-select/async'
import moment from "moment";
import Utilities from '../../../services/commonservice/utilities'
import ModalBox from './ModalBox'
import AddPatient from '../../secure/provider/patient/add-patient/AddPatient'
const PatientSelector = (props) => {
    // Context items
    const stateAndDispatch = useContext(store)
    const state = stateAndDispatch.state
    const [showAdd, setShowAdd] = useState(false)
    const [selectedPatient, setSelectedPatient] = useState(null)

    useEffect(() => {
        if (props.defaultValue) {
            setSelectedPatient(props.defaultValue)
        }
    }, [props.defaultValue])

    const patientLoad = (inputText, callBack) => {
        if (inputText?.length < 3) return;
        let reqObj = {
            SearchTerm: inputText,
            isActive: true,
            isRegistered: true,
            SortField: 'lastName',
            SortField2: 'firstName',
            Asc: true,
            Asc2: true
        }
        CommonService.patientLookup(reqObj)
            .then(res => {
                if (res) {
                    callBack(res.data)
                }
            }
            )
            .catch(err => console.log(err))
    }

    const rePatientLoad = useCallback(debounce(patientLoad, 500), [])

    const setCurrentPatient = async (newPatient) => {
        setSelectedPatient(newPatient ?? null)
        if (props.onChanging) props.onChanging(newPatient?.id ?? null)
        if (props.onSelected) props.onSelected(newPatient?.id ?? null)
        if (props.onSelectedPatient) props.onSelectedPatient(newPatient)
    }

    return (
        <>
            <AsyncSelect
                classNamePrefix="react-select"
                className="react-select-container"
                name="patient"
                loadOptions={rePatientLoad}
                isDisabled={props.disabled}
                placeholder="Search Patient"
                value={selectedPatient}
                onChange={e => {
                    if (e?.id) {
                        setCurrentPatient(e)
                    }
                    else {
                        setCurrentPatient(null)
                    }
                }}
                isClearable={true}
                formatOptionLabel={(option, { context }) => {
                    if (context === "menu") {
                        // Dropdown View
                        return (
                            <div className="d-flex flex-column flex-md-row w-100">
                                <div className={`d-flex align-items-center col-12 ${props.showEmail ? 'col-md-3' : 'col-md-4'} mb-1 mb-md-0`}>
                                    <span className="text-truncate">{option.firstName} {option.lastName}</span>
                                </div>
                                <div className={`d-flex align-items-center col-12 ${props.showEmail ? 'col-md-3' : 'col-md-4'} mb-1 mb-md-0`}>
                                    <i className="icon birthday cake" style={{ marginTop: '-10px', marginRight: '4px' }} /> 
                                    <span>{moment.utc(option.dob).format("M/D/YYYY")}</span>
                                </div>
                                <div className={`d-flex align-items-center col-12 ${props.showEmail ? 'col-md-3' : 'col-md-4'} mb-1 mb-md-0 ${!props.showEmail ? 'justify-content-start justify-content-md-end' : ''}`}>
                                    {option.mobile || option.patientPhone ? (
                                        <>
                                            <i className="icon phone" style={{ marginTop: '-10px', marginRight: '4px' }} />
                                            <span>{Utilities.toPhoneNumber(option.mobile || option.patientPhone)}</span>
                                        </>
                                    ) : null}
                                </div>
                                {props.showEmail && (
                                    <div className="d-flex align-items-center col-12 col-md-3 justify-content-start justify-content-md-end">
                                        {option.email && (
                                            <>
                                                <i className="icon envelope" style={{ marginTop: '-5px', marginRight: '4px' }} />
                                                <span className="text-truncate">{option.email ?? "--"}</span>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    } else {
                        // Selected View
                        return (
                            <div className="d-flex flex-wrap align-items-center" style={{ gap: '8px' }}>
                                <div className="d-flex align-items-center">
                                    <span className="text-truncate">
                                        {option.firstName} {option.lastName}
                                    </span>
                                </div>
                                <div className="d-flex align-items-center">
                                    <i className="icon birthday cake" style={{ marginTop: '-10px', marginRight: '4px' }} />
                                    <span>{moment.utc(option.dob).format("M/D/YYYY")}</span>
                                </div>
                                {(option.mobile || option.patientPhone) && (
                                    <div className="d-flex align-items-center">
                                        <i className="icon phone" style={{ marginTop: '-10px', marginRight: '4px' }} />
                                        <span>{Utilities.toPhoneNumber(option.mobile || option.patientPhone)}</span>
                                    </div>
                                )}
                                {(option.email && props.showEmail) && (
                                    <div className="d-flex align-items-center">
                                        <i className="icon envelope" style={{ marginTop: '-5px', marginRight: '4px' }} />
                                        <span className="text-truncate">
                                            {option.email ?? "--"}
                                        </span>
                                    </div>
                                )}
                            </div>
                        );
                    }
                }}
                getOptionValue={(option) => option.id}
                noOptionsMessage={(e) => {
                    //pass showAddPatient to show add patient button
                    if (!state.permissions.patientModifyPatients || !props?.showAddPatient) {
                        return null;
                      } else {
                        return (
                          <button
                            className='btn btn-primary form-control'
                            onClick={(e) => {
                              e.preventDefault();
                              setShowAdd(true);
                            }}
                          >
                            Add Patient
                          </button>
                        );
                      }
                }}
            />
            <ModalBox open={showAdd} onClose={() => { setShowAdd(false) }} title="Register Patient">
                <AddPatient onClose={() => { setShowAdd(false) }} />
            </ModalBox>
        </>

    )
}
export default PatientSelector